import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { HiCheck } from "react-icons/hi";
import { MdContentCopy } from "react-icons/md";

const CopyButton = ({ text, className = "" }) => {
  const [copied, setCopied] = useState(false);
  const { t } = useTranslation();

  const handleCopy = async () => {
    try {
      // Ưu tiên API hiện đại (hoạt động tốt trên HTTPS mobile)
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // Fallback cho trường hợp navigator.clipboard fail (rất hiếm)
      console.error("Clipboard API failed:", err);
      try {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (fallbackErr) {
        console.error("Fallback copy failed:", fallbackErr);
      }
    }
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      className={`
  inline-flex items-center gap-1.5
  px-3 py-1.5 tabletpro:px-2 tabletpro:py-1 mobile:px-2 mobile:py-1 h-10
  text-[16px] tabletpro:text-[14px] mobile:text-[14px] font-normal

  backdrop-blur-[16px]
  shadow-[inset_0_6px_12px_0_#FFFFFF1F,inset_0_1px_1px_0_#FFFFFF33]

  bg-[#0000001A] text-[#0F172A]
        md:hover:bg-white/60
  dark:md:hover:bg-white/20
        
        dark:bg-white/10 dark:text-[#F8FAFC]
        dark:hover:bg-white/20

        active:bg-white/40
  dark:active:bg-white/30

  cursor-pointer
  touch-manipulation
  select-none

  ${className}
`}
    >
      {copied ? (
        <>
          <HiCheck className="h-4 w-4 tabletpro:h-3 tabletpro:w-3 mobile:h-3 mobile:w-3" />
          <span>{t("copy.copied")}</span>
        </>
      ) : (
        <>
          <MdContentCopy className="h-4 w-4 tabletpro:h-3 tabletpro:w-3 mobile:h-3 mobile:w-3" />
          <span>{t("copy.copy")}</span>
        </>
      )}
    </button>
  );
};

export default CopyButton;